<!-- 编辑设备详情弹框 -->
<template>
  <div class="tree-container">
    <div class="device-search">
      <el-input
        placeholder="请输入搜索关键字"
        prefix-icon="el-icon-search"
        v-model="searchString"
        clearable
      >
      </el-input>
    </div>
    <el-scrollbar style="height: calc(100% - 60px)">
      <el-tree
        ref="tree"
        class="tree-content"
        :data="treeData"
        :expand-on-click-node="false"
        node-key="id"
        :default-expanded-keys="expandedKeys"
        render-after-expand
        :load="asyncLoadNode"
        :lazy="lazyLoad"
        :props="treeProps"
        :highlight-current="true"
        :filter-node-method="filterNode"
        @node-click="nodeClick"
      >
        <template slot-scope="{ node, data }">
          <element-tree-line
            :node="node"
            :showLabelLine="true"
            :indent="16"
            class="tree-line"
          >
            <span class="custom-tree-node">
              <span
                class="node-label"
                :class="deviceWorkGroupCode === data.id ? 'ellipsis' : ''"
                :title="node.label"
                >{{ node.label }}</span
              >
              <span v-if="deviceWorkGroupCode === data.id">
                <div class="area-operator" @click="addClick">
                  <el-button
                    type="text"
                    class="el-icon-plus"
                    size="mini"
                    @click="() => appendArea(data)"
                    title="新增"
                  ></el-button>
                  <el-button
                    v-if="data.parentCode !== '-1'"
                    type="text"
                    class="el-icon-edit-outline"
                    size="mini"
                    v-auth="'/cameralist/devicelist:move'"
                    title="修改"
                    @click="() => editArea(node, data)"
                  ></el-button>
                  <el-button
                    v-if="data.parentCode !== '-1'"
                    type="text"
                    class="el-icon-delete-solid"
                    size="mini"
                    title="删除"
                    @click="() => removeArea(node, data)"
                  ></el-button>
                </div>
              </span>
            </span>
          </element-tree-line>
        </template>
      </el-tree>
    </el-scrollbar>
    <!-- 新增弹窗 -->
    <el-dialog
      :title="state === 1 ? '新增设备组' : '修改设备组'"
      v-ops:width="500"
      v-dialogDrag
      :visible.sync="formShow"
      @close="formClose"
      :close-on-click-modal="false"
    >
      <el-form :model="deviceForm" :rules="rules" ref="form">
        <el-form-item label="设备组名称" label-width="120px" prop="name">
          <el-input v-model="deviceForm.name" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否可见" label-width="120px" prop="isVisible">
          <el-radio-group v-model="deviceForm.isVisible">
            <el-radio label="1">可见</el-radio>
            <el-radio label="0">不可见</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="formClose"> 取消 </el-button>
        <el-button type="primary" @click="saveWorkGroup" v-status> 保存 </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { api } from "../api";
import ElementTreeLine from "element-tree-line";
const trim = (str) => {
  return str.replace(/^\s+|\s+$/g, "");
};
export default {
  components: {
    ElementTreeLine,
  },
  props: {
    deviceType: {
      type: String,
      default: null,
    },
    paramsType: {
      type: String,
      default: null,
    },
  },
  watch: {
    searchString(val) {
      this.$refs.tree.filter(val);
    },
  },
  data() {
    return {
      searchString: "",
      treeData: Object.freeze([]),
      // 展开的节点id
      expandedKeys: [],
      lazyLoad: false,
      treeProps: {
        children: "children",
        label: "name",
        isLeaf: "isLeaf",
      },
      deviceWorkGroupCode: "", //设备组code
      // 根节点code
      rootCode: "",
      state: 1,
      formShow: false,
      deviceForm: {
        name: "",
        isVisible: "1",
      },
      rules: {
        name: [{ required: true, message: "请输入设备组名称", trigger: "blur" }],
        isVisible: [{ required: true, message: "请选择是否可见", trigger: "change" }],
      },
      // 当前被点击修改新增的设备组的信息
      currentGroupInfo: {},
    };
  },
  mounted() {
    this.getWorkGroupTree();
  },
  methods: {
    // 异步加载树子节点 加载子树数据的方法，仅当 lazy 属性为true 时生效
    asyncLoadNode(node, resolve) {
      if (node.data && node.data.children) {
        return resolve(node.data.children);
      } else {
        return resolve([]);
      }
    },
    filterNode(value, data) {
      if (!value) {
        return true;
      }
      return data.name.indexOf(value) !== -1;
    },
    //获取工作组树列表
    getWorkGroupTree() {
      const self = this;
      // 广播设备组接口和摄像机设备组一样，只是入参deviceType，广播枚举是18
      let params = {
        deviceType: this.paramsType,
      };
      this.$fetch(api.queryDeviceWorkGroup, params).then((response) => {
        const result = self.menusDataPro(response.returnObj);
        self.cacheTree = result;
        self.treeData = Object.freeze(result);
        self.rootCode = result[0].id;
        self.deviceWorkGroupCode = self.rootCode;
        self.$nextTick(() => {
          self.expandedKeys = [result[0].id];
          self.$refs.tree.setCurrentKey(result[0]);
        });
        this.$emit("sendData", result);
        // 默认高亮根节点
        // this.$nextTick(function () {
        //   this.$refs.tree.setCurrentKey(self.rootCode);
        //   this.$emit("getCode", self.deviceWorkGroupCode)
        // })
      });
    },
    //递归树结构
    menusDataPro(data) {
      const self = this;
      const result = [];
      if (data !== null) {
        data.forEach(function (item) {
          const entity = {};
          entity.id = item.deviceWorkGroupCode;
          entity.name = item.deviceWorkGroupName;
          entity.parentCode = item.parentCode;
          entity.isVisible = item.isVisible;
          entity.deviceWorkGroupCodeList = item.deviceWorkGroupCodeList;
          entity.isLeaf = !item.hasLeaf || !item.deviceWorkGroupChildren;
          if (item.deviceWorkGroupChildren) {
            entity.children = self.menusDataPro(item.deviceWorkGroupChildren);
          }
          result.push(entity);
        });
        return result;
      }
    },
    // 单击节点时
    nodeClick(data) {
      // console.log('-----节点nodeClick点击----:', data)
      this.deviceWorkGroupCode = data.id;
      this.$emit("getCode", this.deviceWorkGroupCode);
      let parentNode = this.$refs.tree.getNode(data.parentCode);
      // console.log('-----被点击的节点的父节点信息-----:', parentNode)
    },
    addClick(event) {
      event.stopPropagation();
    },
    appendArea(evt) {
      // console.log('----新增工作组----:', evt)
      this.state = 1;
      this.formShow = true;
    },
    removeArea(node, data) {
      // console.log('----删除node----', node);
      // console.log('----删除data----', data);
      let idsArr = [];
      idsArr.push(data.id);
      if (data.children && data.children.length !== 0) {
        data.children.forEach((item) => {
          idsArr.push(item.id);
        });
      }
      this.$confirm("您确定删除该设备组及下属设备组么?", "确认", {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let params = {
          deviceWorkGroupCodeList: idsArr,
        };
        // console.log('---删除ids----', params);
        this.$fetch(api.deleteDeviceWorkGroup, params).then((response) => {
          if (!response.success) {
            this.$message.error(response.msgContent);
            return;
          } else {
            this.getWorkGroupTree();
            this.$emit("refresh");
            this.$message.success("删除成功");
          }
        });
      });
    },
    editArea(node, data) {
      // console.log('----修改node----', node);
      console.log("----修改data----", data);
      this.currentGroupInfo = data;
      this.deviceForm.name = this.currentGroupInfo.name;
      this.deviceForm.isVisible = this.currentGroupInfo.isVisible;
      this.state = 2;
      this.formShow = true;
    },
    saveWorkGroup() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let url = this.state === 1 ? api.addDeviceWorkGroup : api.updateDeviceWorkGroup;
          let params = {};
          if (this.state === 1) {
            params = {
              deviceType: this.paramsType,
              deviceWorkGroupName: this.deviceForm.name,
              isVisible: this.deviceForm.isVisible,
              parentCode: this.deviceWorkGroupCode,
            };
          } else {
            params = {
              deviceWorkGroupCode: this.currentGroupInfo.id,
              deviceWorkGroupName: this.deviceForm.name,
              isVisible: this.deviceForm.isVisible,
            };
          }
          // console.log('===新增的参数====', params);
          this.$fetch(url, params).then((res) => {
            if (res.success) {
              this.$message({
                message: this.state === 1 ? "新增成功" : "修改成功",
                type: "success",
                duration: 2000,
              });
              this.getWorkGroupTree();
              this.$emit("refresh");
              this.formClose();
            } else {
              this.$message.error(res.msgContent);
            }
          });
        } else {
          return false;
        }
      });
    },
    // 新增修改弹窗 关闭清除数据
    formClose() {
      this.formShow = false;
      this.deviceForm = {
        name: "",
        isVisible: "1",
      };
      this.$refs["form"].clearValidate();
    },
  },
};
</script>
<style lang="scss" scoped>
.tree-container {
  height: 100%;
  // margin-right: 10px;
  // display: flex;
  // flex-direction: column;
  .device-search {
    display: flex;
    margin: 15px 16px;
    height: 28px;
    .el-input {
      width: 100%;
    }
  }
  .scroll-bar-view {
    height: calc(100vh - 230px);
    .el-scrollbar__wrap {
      height: calc(100% - 100px);
      .el-scrollbar__view {
        display: inline-block;
        min-width: 100%;
      }
    }
  }
  .tree-content {
    width: fit-content;
    min-width: 100%;
    .el-tree-node__label {
      display: inline-block;
      max-width: 80%;
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;
    }
    .el-tree-node__content {
      height: 40px;
      line-height: 40px;
      &:hover {
        background: rgb(45, 73, 118);
      }
      .custom-tree-node {
        width: 100%;
        height: 40px;
        line-height: 40px;
        .area-operator {
          position: absolute;
          right: 0;
          display: block;
          width: 80px;
          // margin: 0 10px;
          .el-button {
            font-size: 15px;
            // color: #fff !important;
          }
        }
      }
      &:before {
        margin-top: -26px !important;
      }
    }
  }
}
</style>
